export default {
    "deleted": "Fisierul a fost sters cu succes",
    'not_found': 'Fisierul nu a fost gasit',
    'download': 'Descarca'
}
